import { apiClient } from '@/shared/api/client'
import type { VerificationResult } from '@/shared/types/api.types'
import { API_ENDPOINTS } from '@/shared/lib/constants'

/**
 * Verify PDF signature via backend API
 *
 * @param file - PDF file to verify
 * @param localHash - SHA-256 hash computed locally
 * @returns Verification result
 */
export async function verifyPDFSignature(
  file: File,
  localHash: string
): Promise<VerificationResult> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post<VerificationResult>(
    API_ENDPOINTS.VERIFY_SIGNATURE,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        local_hash: localHash,
      },
    }
  )

  return response.data
}
